import {
	NgModule,
    ModuleWithProviders
}                                   from "@angular/core";
import {
	CommonModule
}									from "@angular/common";
import {
    ReactiveFormsModule,
    FormsModule
}                                   from "@angular/forms";
import {
	RouterModule
}									from "@angular/router";
import {
	NgbModule
}									from "@ng-bootstrap/ng-bootstrap";

import {
    Md2DialogModule,
    Md2Autocomplete,
    Md2Datepicker,
    Md2Clock,
    Md2TooltipComponent,
    Md2Tooltip,
    HighlightPipe,
    DateLocale,
    DateUtil,

    CtmMessage,
    CtmTable,
    CtmTextarea,
    CtmTextbox,
    CtmNumericTextbox,
    CtmSearchTextbox,
    CtmSearchCriteria
}									from "./components";
import {
    ApiService,
    
    CtmMessageService,
    CtmTranslateService,
    CtmApiLoader,
    CtmTableService,

    AutocompleteService
}                                   from "./services";
import {
    CtmTranslatePipe,
    CtmDatePipe,
    CtmNumericPipe
}                                   from "./pipes";

/*

import {
}                                   from "./directives";
*/

import {
    OverlayModule, 
    CompatibilityModule,
    PlatformModule,
    PortalModule,
    StyleModule
}                                   from "./_core.md2";

import {
    DragDropConfig,
    DragDropService,
    DragDropSortableService,
    dragDropServiceFactory,
    dragDropSortableServiceFactory,
    DraggableComponent,
    DraggableHandleComponent,
    DroppableComponent,
    SortableContainer,
    SortableComponent,
    SortableHandleComponent
}                                   from "../_custom"

const COMMON_COMPONENTS = [
    Md2Datepicker,
    Md2Clock,
    Md2TooltipComponent,

    CtmMessage,
    CtmTable,
    CtmTextarea,
    CtmTextbox,
    CtmNumericTextbox,
    CtmSearchTextbox,
    CtmSearchCriteria,

    DraggableComponent,
    DraggableHandleComponent,
    DroppableComponent,
    SortableContainer,
    SortableComponent,
    SortableHandleComponent
];
const COMMON_DIRECTIVES = [
    Md2Autocomplete,
    HighlightPipe,
    Md2Tooltip
];
const COMMON_PROVIDERS = [
    DateLocale, 
    DateUtil,

    DragDropConfig,
    { 
        provide: DragDropService,
        useFactory: dragDropServiceFactory 
    },
    { 
        provide: DragDropSortableService, 
        useFactory: dragDropSortableServiceFactory, 
        deps: [DragDropConfig] 
    }
];
const COMMON_PIPES = [
    CtmTranslatePipe,
    CtmDatePipe,
    CtmNumericPipe
];
const COMMON_SERVICES = [
    ApiService,

    AutocompleteService,

    CtmMessageService,
    CtmTranslateService,
    CtmApiLoader,
    CtmTableService
];

const MD2_MODULES = [
    Md2DialogModule
];

@NgModule({
    declarations: [
		...COMMON_PIPES,
        ...COMMON_DIRECTIVES,
        ...COMMON_COMPONENTS  
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,

        OverlayModule, 
        CompatibilityModule, 
        PlatformModule,
        PortalModule,
        StyleModule,

        Md2DialogModule.forRoot()
    ],
    providers: [
        ...COMMON_PROVIDERS
    ],
    exports: [
		...COMMON_PIPES,
        ...COMMON_DIRECTIVES,
        ...COMMON_COMPONENTS,
        ...MD2_MODULES
    ],
    entryComponents: [
        Md2TooltipComponent,
        Md2Datepicker
    ]
})
export class CtmModule {
    static forRoot(): ModuleWithProviders {
        return <ModuleWithProviders>{
            ngModule: CtmModule,
            providers: [
                ...COMMON_SERVICES
            ]
        };
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/common.module.ts